import { gql } from "@apollo/client";

export const GET_ACCOUNT = gql`
  query GetAccount($id: ID!) {
    account(id: $id) {
      id
      name
      accountType
      url
      status
      startAt
    }
  }
`;

export const ACCOUNTS = gql`
  query GetAccounts(
    $name: String
    $accountType: [String]
    $status: [Status]
    $first: Int
    $after: String
  ) {
    accounts(
      name: $name
      accountType: $accountType
      status: $status
      first: $first
      after: $after
    ) {
      edges {
        cursor
        node {
          id
          name
          accountType
          url
          status
          refreshedAt
          createdAt
          astradaCard {
            network
            enrollmentId
            networkReference
          }
        }
      }
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const GET_PERSONAL_BANK_ACCOUNT = gql`
  query personalBankAccount($programId: ID) {
    personalBankAccount(programId: $programId) {
      id
      name
      last4
      status
      microDepositUrl
    }
  }
`;

export const USER_HAS_PERSONAL_BANK_ACCOUNT = gql`
  query userHasPersonalBankAccount($userId: ID!) {
    userHasPersonalBankAccount(userId: $userId)
  }
`;

export const LOAD_ASTRADA_ACCOUNT = gql`
  query astradaAccount {
    astradaAccount {
      companyName
      externalId
    }
  }
`;

export const ADD_FUNDS = gql`
  mutation addFunds($input: FundsInput) {
    addFunds(input: $input) {
      isSuccess
    }
  }
`;

export const TRANSFER_FUNDS = gql`
  mutation transferFundsToCustomerAccount($input: TransferInput) {
    transferFundsToCustomerAccount(input: $input) {
      isSuccess
    }
  }
`;

export const ADD_AUTO_FUNDING = gql`
  mutation addAutoFunding(
    $input: FundingScheduleInput
    $fromAccountId: String!
    $toAccountId: String!
  ) {
    addAutoFunding(
      input: $input
      fromAccountId: $fromAccountId
      toAccountId: $toAccountId
    )
  }
`;

export const DELETE_AUTO_FUNDING = gql`
  mutation deleteAutoFunding($id: ID!) {
    deleteAutoFunding(id: $id)
  }
`;

export const GET_UPCOMING_TRANSFER = gql`
  query upcomingTransfers {
    upcomingTransfers {
      edges {
        cursor
        node {
          id
          accountNumber
          amount
          currency
          date
          type
          memo
          user {
            id
            firstName
            lastName
          }
          schedule {
            transferDate
            isRepeatJob
            repeatOnDay
            repeatDayOfMonth
            repeatDayOfWeek
            repeatWeekday
            repeatNeverEnd
            repeatEndOn
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        total
      }
    }
  }
`;

export const REDEEM_REWARDS = gql`
  mutation redeemRewards($input: RedeemRewardsInput!) {
    redeemRewards(input: $input) {
      id
      type
      status
      amount
    }
  }
`;

export const REPAY_CHARGE_ACCOUNT = gql`
  mutation repayChargeAccount($input: RepayChargeAccountInput!) {
    repayChargeAccount(input: $input) {
      isSuccess
    }
  }
`;

export const REQUEST_BULK_ENROLLMENT = gql`
  mutation requestBulkEnrollment(
    $type: String
    $networkReference: String
    $id: String
  ) {
    requestBulkEnrollment(
      type: $type
      networkReference: $networkReference
      id: $id
    )
  }
`;

export const UPDATE_ASTRADA_CONNECTION = gql`
  mutation updateAstradaConnection(
    $id: String
    $externalId: String
    $feedId: String
  ) {
    updateAstradaConnection(id: $id, externalId: $externalId, feedId: $feedId)
  }
`;
